// Создано tools/art/root_curves.py — не править руками.
/** Положение бёдер клипа вперёд по кадрам 30 к/с, пиксели мира: ход корня приёма. */
export const ROOT_CURVES: Readonly<Record<string, readonly number[]>> = {
  "lead-jab": [
    0.0, 0.7, 1.8, 3.5, 6.0, 8.9, 12.3, 15.7, 19.0, 22.4, 26.2, 30.2, 33.8, 36.6, 38.8, 40.4, 41.6, 42.2, 42.1, 41.3,
    39.8, 37.7, 35.0, 31.8, 28.4, 25.1, 22.3, 19.8, 17.6, 15.6, 14.0, 12.8, 12.0, 11.5, 11.2, 10.8, 10.4, 9.6, 8.5, 7.3,
    6.0, 4.5, 3.1, 1.6, 0.4, -0.5, -1.2, -1.6, -1.8, -1.8, -1.5, -1.1, -0.7, -0.3,
  ],
  "punch-combo": [
    0.0, -0.1, -0.1, -0.2, -0.2, -0.3, -0.4, -0.4, -0.4, -0.3, 0.0, 0.6, 1.3, 2.2, 3.1, 4.1, 5.1, 5.9, 6.6, 7.3, 8.2,
    9.0, 9.8, 10.6, 11.2, 11.7, 12.1, 12.4, 12.4, 12.5, 12.5, 12.1, 11.6, 11.2, 10.9, 10.7, 10.7, 10.6, 10.4, 10.3,
    10.2, 10.0, 9.5, 8.8, 7.9, 7.0, 6.4, 5.7, 4.9, 4.2, 3.5, 2.9, 2.4, 1.9, 1.5, 1.1, 0.8, 0.7, 0.5, 0.5, 0.4, 0.3, 0.3,
    0.2, 0.1, 0.1,
  ],
  "side-kick": [
    0.0, -0.2, -0.4, -0.5, -0.0, 1.2, 3.3, 6.4, 10.1, 13.7, 16.3, 18.2, 20.0, 21.8, 24.2, 27.2, 30.3, 33.0, 35.0, 36.4,
    38.1, 39.6, 40.5, 41.5, 42.2, 42.7, 42.8, 43.1, 44.0, 44.4, 44.5, 44.2, 43.0, 40.7, 38.0, 35.1, 32.2, 29.7, 27.3,
    25.0, 23.4, 21.7, 19.4, 16.5, 13.3, 10.2, 7.6, 5.8, 4.3, 3.1, 2.3, 1.7, 1.2, 0.8, 0.5, 0.4, 0.3, 0.2, 0.2, 0.1, 0.0,
  ],
  "mma-kick": [
    0.0, -0.4, -0.9, -1.4, -2.2, -3.0, -3.7, -3.9, -3.6, -2.5, -0.1, 3.9, 9.0, 14.6, 19.8, 23.9, 26.6, 28.2, 28.9, 28.9,
    28.6, 29.0, 30.2, 31.9, 32.8, 34.0, 35.4, 36.5, 37.1, 37.0, 36.0, 34.4, 32.4, 30.3, 28.0, 25.6, 23.1, 20.7, 18.6,
    16.8, 15.1, 13.5, 11.9, 10.4, 8.6, 6.8, 4.9, 3.2, 1.9, 0.8, 0.0,
  ],
  "elbow-punch": [
    0.0, 0.1, 0.6, 1.6, 3.3, 5.1, 7.3, 10.0, 13.1, 17.1, 22.0, 27.6, 34.1, 40.5, 46.3, 50.7, 54.2, 57.1, 59.6, 61.5,
    62.3, 62.7, 62.8, 62.4, 61.8, 60.9, 59.8, 58.6, 57.0, 55.1, 52.7, 49.7, 46.0, 42.2, 38.4, 34.7, 31.0, 27.8, 24.8,
    22.3, 20.2, 18.4, 16.7, 15.0, 13.4, 11.6, 9.5, 7.2, 4.8, 2.6, 1.0, 0.2,
  ],
  "elbow-uppercut-combo": [
    0.0, 0.1, 0.3, 0.4, 0.5, 0.6, 0.6, 0.5, 0.4, 0.4, 0.6, 1.1, 1.8, 2.6, 3.5, 4.2, 4.7, 5.0, 4.9, 4.8, 4.8, 5.3, 6.2,
    7.2, 8.2, 9.0, 9.7, 10.2, 10.3, 10.3, 10.4, 10.8, 11.8, 13.2, 14.5, 15.5, 15.9, 16.0, 16.0, 16.0, 16.0, 16.1, 16.1,
    15.9, 15.7, 15.6, 15.4, 15.2, 15.0, 14.8, 14.3, 13.5, 12.5, 11.2, 9.7, 8.1, 6.4, 4.6, 3.1, 1.7, 0.8, 0.2, -0.1,
    -0.2, -0.2, -0.1, -0.0, 0.1, 0.1, 0.1, 0.1, 0.1, 0.0,
  ],
  "hurricane-kick": [
    0.0, 6.1, 13.7, 22.3, 31.3, 40.0, 47.6, 53.9, 58.5, 61.7, 64.0, 66.0, 68.5, 71.9, 76.9, 83.4, 91.3, 100.1, 109.0,
    117.5, 124.8, 130.7, 134.9, 137.9, 140.0, 142.1, 144.7, 148.5, 153.9, 160.8, 169.0, 177.8, 186.7, 195.0, 201.9,
    207.4, 211.3, 214.0, 216.0, 218.1, 221.0, 225.2, 231.0, 238.2, 246.6, 255.6, 264.4, 272.3, 279.0, 284.0, 287.5,
    290.0, 292.0, 294.3, 297.5, 302.0,
  ],
  "roundhouse-kick": [
    0.0, 0.1, 0.2, 0.3, 0.4, 0.6, 0.7, 0.9, 1.0, 1.3, 1.5, 1.9, 2.3, 2.9, 3.8, 5.1, 7.0, 9.5, 12.4, 15.4, 18.5, 21.3,
    23.2, 24.4, 24.9, 24.8, 24.6, 23.9, 23.0, 23.0, 24.2, 26.3, 27.7, 27.9, 29.5, 32.2, 34.7, 36.7, 38.6, 40.3, 41.7,
    43.2, 44.4, 45.4, 46.5, 47.6, 48.5, 49.4, 50.4, 51.4, 52.4, 53.3, 54.1, 54.8, 55.4, 55.8, 56.1, 56.4, 56.6, 56.8,
    57.0, 57.1, 57.1, 57.2, 57.3,
  ],
  "illegal-elbow-punch": [
    0.0, -0.5, -0.8, -0.9, -0.9, -0.7, -0.3, 0.3, 1.1, 2.0, 3.1, 4.5, 6.2, 8.3, 10.5, 12.5, 14.2, 15.6, 16.8, 17.8,
    19.0, 20.2, 21.1, 21.7, 21.9, 21.8, 21.5, 20.9, 20.3, 19.6, 18.8, 17.8, 16.7, 15.4, 13.9, 12.1, 10.1, 8.0, 6.0, 4.0,
    2.2, 0.5, -0.9, -2.0, -2.8, -3.3, -3.5, -3.6, -3.6, -3.4, -2.9, -2.2, -1.4, -0.5, 0.4, 1.2, 1.8, 2.5, 3.0, 3.4, 3.5,
    3.4, 3.2, 2.7, 2.1, 1.5, 0.8, 0.3,
  ],
};
